import { render, staticRenderFns } from "./条款.vue?vue&type=template&id=083b21bd"
import script from "./条款.vue?vue&type=script&lang=js"
export * from "./条款.vue?vue&type=script&lang=js"
import style0 from "./条款.vue?vue&type=style&index=0&id=083b21bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports